module.exports = __webpack_public_path__ + "img/912381-1565625545.aa0365e3.jpg";